import { render, staticRenderFns } from "./SampleValidationHeat.vue?vue&type=template&id=4ca1bffc&scoped=true"
import script from "./SampleValidationHeat.vue?vue&type=script&lang=js"
export * from "./SampleValidationHeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca1bffc",
  null
  
)

export default component.exports